import { Component, OnInit } from '@angular/core';
import { GamesService } from '../Services/games.service';
import { Router } from '@angular/router';
import { OpreatorModelModule } from '../fqa/model/opreator-model.module';
import { TermModule } from '../fqa/model/terms.module';

@Component({
  selector: 'app-term-condition',
  templateUrl: './term-condition.component.html',
  styleUrls: ['./term-condition.component.css']
})
export class TermConditionComponent implements OnInit {
  terms: TermModule;
  editEnable: boolean;
  Eterm: any;
  new_cat: boolean;
  new_faq: boolean;
  new_ques: string;
  new_answer: string;
  opraitorId: string= '';
  opraitorlang: string = 'en';


   // edite 2 way binding vars
  edit_ques: string;
  edit_answer: string;
  edit_opraitorId: string;
  edit_lang: string;

  editableCat: string;
  opraitors: any[];
  constructor( private games: GamesService, private router: Router ) { }

  ngOnInit() {
    // this.getAllCats;
    this.games.getMygamesOpreators().subscribe(
      next => { this.opraitors = next['data'] as OpreatorModelModule[] }
      )

      this.games.getAllTerms().subscribe(next => { this.terms = next as TermModule })

}

selectQuzOpraitor(event: any) {
    this.opraitorId = event.target.value;
    this.edit_opraitorId = event.target.value;
  }
  selectLang(lang: string) {
    this.opraitorlang = lang;
  }

  editTerm(term: any) {
      this.editEnable = true;
      console.log('faq', term);
      this.Eterm = term;
      console.log(this.Eterm );

      this.edit_ques = term.term;
      this.edit_answer = term.answer;
      this.edit_opraitorId = term._p_operator_id;
      this.edit_lang = term.lang;
    }

     // save changes in row ;
    save(id) {
      const form = new FormData();
      form.set('term', this.edit_ques);
      form.append('operator_id', this.edit_opraitorId);
      form.append('lang',  this.edit_lang);
      console.log(form , "after int")

      this.games.updateTerms(id, form).subscribe(next => {
        console.log(next);
         this.editEnable = false; this.Eterm = '';
       // location.reload();
       console.log(form)
    },
     error => { console.log(error); });
    }

    deletaTerm(id){
      const conf = confirm('are you sure you whant delete this row ?');
      if (conf) {
        this.games.deletaTerm(id).subscribe(next => { console.log(next)
          alert("Done");
          window.location.reload()
        } );
     
    } }

    newTerm(){
      let form = new FormData();
      form.append('term', this.new_ques);
      form.append('operator_id', this.opraitorId);
      form.append('lang', this.opraitorlang);

       this.games.NewTerms(form).subscribe(next => { 
         console.log(next);
         alert("terms added succesfuly");
         location.reload(); 
      } )
        

      // , error => { console.log(error) });



  /**
   * get all
   *@description get all cats from backend 
   */

  // getAllCats(){
  //   this.games.getAllCats().subscribe(next=>{
  //     this.cats=next['cat_lists'];
  //     console.log(next['cat_lists']);
  //   },error=>{console.log(error)});
  // }

    }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/term-condition/term-condition.component.ts